module.exports = __webpack_public_path__ + "img/hm.fc838ac0.svg";